import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { HardHat } from "lucide-react";
import { btnPrimary, inputCls, Field } from "../components/Modal";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState({ password: "", confirm: "" });
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.password !== pw.confirm) { setError("Les mots de passe ne correspondent pas"); return; }
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password: pw.password });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm space-y-5" data-testid="reset-page">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-accent flex items-center justify-center"><HardHat className="h-6 w-6 text-accent-foreground" /></div>
          <div className="font-heading font-extrabold text-xl">QuincailleriePro</div>
        </div>
        <h1 className="font-heading text-2xl font-bold">Nouveau mot de passe</h1>
        {done ? (
          <div className="space-y-4" data-testid="reset-success">
            <div className="p-3 rounded-lg bg-emerald-50 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300 text-sm font-medium">Mot de passe réinitialisé avec succès.</div>
            <button data-testid="reset-goto-login" onClick={() => navigate("/login")} className={`${btnPrimary} w-full h-11`}>Se connecter</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            {error && <div data-testid="reset-error" className="p-3 rounded-lg bg-rose-50 text-rose-700 dark:bg-rose-950 dark:text-rose-300 text-sm font-medium">{error}</div>}
            {!token && <div className="p-3 rounded-lg bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-300 text-sm">Lien invalide : aucun jeton fourni.</div>}
            <Field label="Nouveau mot de passe"><input data-testid="reset-password" type="password" required minLength={6} value={pw.password} onChange={(e) => setPw({ ...pw, password: e.target.value })} className={inputCls} /></Field>
            <Field label="Confirmer"><input data-testid="reset-confirm" type="password" required value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} className={inputCls} /></Field>
            <button data-testid="reset-submit" disabled={loading || !token} className={`${btnPrimary} w-full h-11`}>
              {loading ? "Enregistrement..." : "Enregistrer"}
            </button>
            <Link to="/login" className="block text-center text-primary text-sm font-semibold hover:underline">← Retour à la connexion</Link>
          </form>
        )}
      </div>
    </div>
  );
}
